import React, { useEffect, useState } from "react";

interface ImagePreviewModalProps {
  isOpen: boolean;
  imageUrl: string | undefined;
  onClose: () => void;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  imageUrl,
  onClose,
}) => {
  const [show, setShow] = useState(isOpen);

  useEffect(() => {
    if (isOpen) setShow(true);
  }, [isOpen]);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      onClose();
    }, 200); // match animation duration
  };

  if (!isOpen && !show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div
        className={`relative ${isOpen ? "animate-pop-in" : "animate-pop-out"} 
                   bg-gray-800 rounded-2xl shadow-2xl border-2 border-white 
                   w-[800px] h-[600px] max-w-[90vw] max-h-[80vh] overflow-hidden`}
        style={{
          animation: `${isOpen ? "popIn" : "popOut"} 0.2s cubic-bezier(0.4,0,0.2,1)`,
          willChange: "opacity, transform",
        }}
      >
        <div className="w-full h-full flex items-center justify-center">
          <img
            src={imageUrl}
            alt="Preview"
            className="w-full h-full object-contain"
            onError={(e) => {
              e.currentTarget.src =
                "https://via.placeholder.com/800x600?text=Image+Load+Failed";
            }}
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
          <div className="text-white text-sm">
            {imageUrl?.split("/").pop() || "Image Preview"}
          </div>
        </div>
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 bg-white bg-opacity-80 rounded-full p-2 hover:bg-opacity-100 transition"
          aria-label="Close preview"
        >
          <span className="text-xl font-bold text-gray-700">&times;</span>
        </button>
      </div>
      {/* Animation keyframes */}
      <style>
        {`
          @keyframes popIn {
            0% {
              opacity: 0;
              transform: scale(0.8);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }
          @keyframes popOut {
            0% {
              opacity: 1;
              transform: scale(1);
            }
            100% {
              opacity: 0;
              transform: scale(0.8);
            }
          }
          .animate-pop-in {
            animation: popIn 0.2s cubic-bezier(0.4,0,0.2,1);
          }
          .animate-pop-out {
            animation: popOut 0.2s cubic-bezier(0.4,0,0.2,1);
          }
        `}
      </style>
    </div>
  );
};

export default ImagePreviewModal;